
<div class="price_part_lookz" *ngIf="!loader">
    <div class="create_opl">
        <sm-title-bar pageTitle="Current pack & recharge" [backWithParams]="true"></sm-title-bar>
           <div class="likely_section">
                <div class="row">
                    <div class="col-sm-8">
                        <div class="create_employees_ben">
                            <mat-card>
                            <div class="wht_headinght">
                                <h3>Accessible feature and functionality</h3>
                                <p>Here's the list of operations you can perform on this business with your current pack.
                                Functionality with green ticks are open to access.</p>
                            </div>
                            <div class="assistant_benf">
                                <div class="row">
                                    <div class="col-sm-6" *ngFor="let item of applicableFunctionality">
                                        <div class="cardfg_se ">
                                            <mat-icon *ngIf="item.isValid == 1">check</mat-icon>
                                            <mat-icon class="closeb" *ngIf="item.isValid == 0">close</mat-icon>
                                            {{item.functionality_name}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </mat-card>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="choose_sucri">
                            <mat-card *ngIf="currentPlan.length > 0">
                              <div class="nus_nu_sectionm">
                                <div class="create_thy">
                                    <h1>Active business subscription</h1>
                                    <h3>{{currentPlan[0].planName}}</h3>
                                    <p>{{currentPlan[0].description}}</p>
                                </div>
                                <div class="current_pack_rec">
                                    <div class="progress-bar">
                                        <div class="progress-circle active bhy_md">
                                          <div class="progress-circle-dot-container">
                                            <div class="progress-circle-dot"></div>
                                          </div>
                                        </div>
                                        <div class="progress-circle active bhy_sd">
                                          <div class="progress-circle-dot-container">
                                            <div class="progress-circle-dot"></div>
                                          </div>
                                        </div>
                                        <div id="progress-line" class="progress-line"></div>
                                      </div>
                                      <div class="curr_seci">
                                <h4>Valid From: {{currentPlan[0].fromDate | date}}</h4>
                                <h4>Valid till: {{currentPlan[0].toDate | date}}</h4>
                            </div>
                               </div>

                                <div class="secr_check_secu">
                                    <p><span class="grren_tht"><mat-icon>task_alt</mat-icon> Active </span></p>
                                </div>
                                <div class="sed_button">
                                    <button (click)="renewBusiness()" flat type="button">Recharge business</button>
                                </div>
                            </div>
                        </mat-card>
                            <mat-card style="margin-top: 20px;" *ngIf="currentPlan.length > 0 && (whatsappQuota.length > 0 || emailQuota.length > 0) ">
                              <div class="nus_nu_sectionm">
                                <div class="create_thy">
                                    <h1>WhatsApp & Email usage</h1>
                                </div>
                                <div class="current_pack_rec">
                                    
                                    <div class="">
                                        <div *ngIf="emailQuota.length > 0">
                                            <h4 style="margin-bottom: 10px !important; font-weight: 600;">Email usage quota: {{emailQuota[0].quota}}</h4>
                                            <p style="margin-bottom: 10px !important;color: #888;">Period: {{emailQuota[0].quota_start_date | date}} - {{emailQuota[0].quota_end_date | date}}</p>
                                            <p style="color: #888;">Available: {{emailQuota[0]?.quota - emailQuota[0]?.usage_count}}</p>

                                        </div>
                                        <div *ngIf="whatsappQuota.length > 0">
                                            <div style="margin-bottom: 20px;"></div>
                                            <h4 style="margin-bottom: 10px !important;font-weight: 600;">WhatsApp usage quota: {{whatsappQuota[0].quota}}</h4>
                                            <p style="margin-bottom: 10px !important;color: #888;">Period: {{whatsappQuota[0].quota_start_date | date}} - {{whatsappQuota[0].quota_end_date | date}}</p>
                                            <p style="color: #888;    margin-bottom: 0px;">Available: {{whatsappQuota[0]?.quota - whatsappQuota[0]?.usage_count}}</p>

                                        </div>
                            </div>
                               </div>

                            </div>
                        </mat-card>

                        <!-- Placeholder card start -->
                            <div class="placeholder_subsc" *ngIf="currentPlan.length == 0">
                            <mat-card>
                                <div class="business_icons">
                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M392 347v45h45M364.404 288.142 221.243 30.452C216.123 21.236 206.29 15 195 15s-21.123 6.236-26.243 15.452l-150 270A29.862 29.862 0 0 0 15 315c0 16.569 13.431 30 30 30h250.105M195 135v60" style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" fill="none" stroke="#767676" stroke-width="30" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" data-original="#000000" class="" opacity="1"></path><circle cx="392" cy="392" r="105" style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" fill="none" stroke="#767676" stroke-width="30" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" data-original="#000000" class="" opacity="1"></circle><path d="M195 255h0" style="stroke-width:30;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;" fill="none" stroke="#767676" stroke-width="30" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" data-original="#000000" class="" opacity="1"></path></g></svg>
                                </div>
                                <h3>No premium paid pack added
                                </h3>
                                <p>This business is running without a premium pack. You can access limited functionality and no premium features.</p>
                                <div class="sed_button">
                                    <button flat type="button" (click)="renewBusiness()">Recharge business</button>
                                </div>
                            </mat-card>
                            </div>
                        <!-- Placeholder card end -->



                        </div>
                    </div>
                    
                </div>
        </div>
    </div>
</div>
